import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AppPublic from "./App-Public";
import AppAdmin from "./App-Admin";
import AppWebsite from "./App-Website";
import TagManager from "react-gtm-module";

function App() {
  const tagManagerArgs = {
    gtmId: "GTM-WH4BX7ZX",
  };
  TagManager.initialize(tagManagerArgs);

  const [type, setType] = useState("");
  const location = useLocation();

  const setPageType = (path) => {
    let type = "";
    const publicPages = ["", "/", "signin", "signup", "about-us"];

    if (publicPages.includes(path.split("/")[1])) {
      type = "public";
    } else if (path.split("/")[1] === "website") {
      type = "website";
    } else {
      type = localStorage.getItem("admin-token") ? "admin" : "not-found";
    }
    setType(type);
  };

  useEffect(() => {
    setPageType(location.pathname);
  }, [location]);

  return (
    <React.Fragment>
      {type === "public" && <AppPublic />}

      {type === "admin" && <AppAdmin />}

      {type === "website" && <AppWebsite />}

      {type === "not-found" && (
        <h2 style={{ textAlign: "center", opacity: "0.2" }}>Page not Found</h2>
      )}
    </React.Fragment>
  );
}

export default App;
